<template>
  <div class="type-of-review wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">导出评阅结果</label>
        <div v-if="stuInfo.length > 0">
          <p class="g-mb g-mt-20">学生信息</p>
          <Row>
            <Col span="3" class="g-mb" v-for="(item, index) in stuInfo" :key="index">
              <Checkbox v-model="item.s" true-value='1' false-value='0'>{{item.t}}</Checkbox>
            </Col>
          </Row>
        </div>
        <div v-if="expertInfo.length > 0">
          <p class="g-mb g-mt-20">专家信息</p>
          <Row>
            <Col span="3" class="g-mb" v-for="(item, index) in expertInfo" :key="index">
              <Checkbox v-model="item.s" true-value='1' false-value='0'>{{item.t}}</Checkbox>
            </Col>
          </Row>
        </div>
        <div v-if="paperInfo.length > 0">
          <p class="g-mb g-mt-20">论文信息</p>
          <Row>
            <Col span="3" class="g-mb" v-for="(item, index) in paperInfo" :key="index">
              <Checkbox v-model="item.s" true-value='1' false-value='0'>{{item.t}}</Checkbox>
            </Col>
          </Row>
        </div>
        <div class="g-jc-ai">
          <Button @click="handleCancel">取消</Button>
          <Button type="primary" class="g-ml-24" @click="handleSave">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import exportFieldConfig from '../../../assets/js/exportFieldConfig'
// 导出评阅结果
export default {
  name: 'exportFieldConfig',
  data () {
    return {
      stuInfo: {},
      expertInfo: {},
      paperInfo: {}
    }
  },
  created () {
    this.stuInfo = exportFieldConfig.stuInfo
    this.expertInfo = exportFieldConfig.expertInfo
    this.paperInfo = exportFieldConfig.paperInfo
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.post('sys/sysUserExportConfig/getSysUserExportConfig').then(res => {
        this.stuInfo = res.data.filter(item => item.b === 'st')
        this.expertInfo = res.data.filter(item => item.b === 'ex')
        this.paperInfo = res.data.filter(item => item.b === 'pa')
      })
    },
    handleCancel () {
      console.log('handleCancel')
    },
    handleSave () {
      const temp = this.stuInfo.concat(this.expertInfo).concat(this.paperInfo)
      this.post('sys/sysUserExportConfig/saveOrUpdate', {fieldList: temp}).then(res => {
        console.log(res, 'handleSave')
        this.$Message.success(res.msg)
        this.fetchList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .type-of-review{
    .wrap-form-item {
      height: 32px;
      line-height: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/exportFieldConfig.vue